import React from "react";
import { Container, Image } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import support from "../../assets/images/icon-support-small.svg";
import { logFirebaseEvent } from "../../shared/utility";
import classes from "./Support.module.css";

const Support = (props) => {
  logFirebaseEvent("Support");
  const supportUrl =
    props.i18n.language === `en`
      ? `${process.env.REACT_APP_SUPPORT_PAGE}`
      : `${process.env.REACT_APP_SUPPORT_PAGE_SP}`;
  console.log("props.i18n", props.i18n);
  return (
    <Container fluid>
      <div className="inner-banner">
        <div className="inner-banner-title">
          <h3>{props.t("header.support")}</h3>
          <Image
            src={support}
            alt="support"
            className={classes.stockimage}
            data-test="stockIMG"
            style={{ right: 22 }}
          />
        </div>
      </div>
      <div className="iframe-section">
        <iframe src={supportUrl} title="support"></iframe>
      </div>
      {/* <div className="tabs">
        <div className="web-version">
          <div className="faq s-title" id="faq">Frequently Answered Questions</div>

          <Dropdown className="contact" id="contact">
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              <Image src={contactWhite} alt={contactWhite} />
              <span>Contact Us</span>
            </Dropdown.Toggle>

            <Dropdown.Menu id="contactInfo">
              <Dropdown.Item>
                <div className="contact-info">
                  <div className="title">App/Web Support</div>
                  <div className="call"><a href="tel:888-215-3351"><Image src={call} alt={call} /></a> <Image src={call} alt={call} /><span>888-215-3351</span></div>
                  <div className="email"><a href="mailto:mobilehelp@advancedpricing.com"><span>Email</span><Image src={email} alt={email} /></a></div>
                  <div className="clear"></div>
                </div>
              </Dropdown.Item>

              <Dropdown.Item>
                <div className="contact-info">
                  <div className="title">Advocacy Team</div>
                  <div className="call"><a href="tel:800-425-9373"><Image src={call} alt={call} /></a> <Image src={call} alt={call} /><span>800-425-9373</span></div>
                  <div className="email"><a href="mailto:info@advancedpricing.com"><span>Email</span><Image src={email} alt={email} /></a></div>
                  <div className="clear"></div>
                </div>
              </Dropdown.Item>
              <Dropdown.Item>
                <div className="contact-info">
                  <div className="title">Care Navigation</div>
                  <div className="call"><a href="tel:888-641-8834"><Image src={call} alt={call} /></a> <Image src={call} alt={call} /><span>888-641-8834</span></div>
                  <div className="email"><a href="mailto:carenavigator@advancedpricing.com"><span>Email</span><Image src={email} alt={email} /></a></div>
                  <div className="clear"></div>
                </div>
              </Dropdown.Item>


            </Dropdown.Menu>
          </Dropdown>
          <div className="clear"></div>
        </div>
        <div className="mobile-version">
          <a className="faq active" id="faqTab">Frequently Answered Questions</a>
          <Dropdown className="contact" id="contact">
            <Dropdown.Toggle variant="success" id="dropdown-basic">
              <Image src={contactWhite} alt={contactWhite} />
              <span>Contact Us</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
              <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
              <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className="clear"></div>
        </div>
      </div>*/}

      {/* <Accordion className="custom-accordian"> 
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="0">
            <h2>What is the Provider Search Used For?</h2>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <h4>What is the Provider Search Used For?</h4>
              <p>AMPS Procedure Search can help you find Providers in your local market that are accepting of your Program. These Providers are ranked based on AMPS historical data which accounts for cost, quality, location, and prior utilization.</p>
              <h4>What Does This Provider Score Mean</h4>
              <p>AMPS rates Providers based on Member experience regarding pre-care and post-care billing. The higher the Provider Score, the better the experience is.</p>
              <h4>Can I still go to Provider That Does Not Have a Score</h4>
              <p>Yes! If a Provider does not have a score, it just means we do not have enough experience with them. If you encounter any issues seeking services there, call your health plan and they will verify your benefits with the Provider.</p>
              <h4>I Found a Provider, Now What</h4>
              <ol>
                <li>Call your Provider’s office and set up an appointment.</li>
                <li>Call your Health Plan, give your Provider’s information, and ask that they verify benefits PRIOR to your appointment.</li>
                <li>Take your ID card to your appointment. If the Provider’s office has further questions when you arrive, ask them to call the number on your card to your plan.</li>
              </ol>
              <h4>The Provider Has Moved or I had a Bad Experience at a Provider</h4>
              <p>Please submit feedback on any Provider that you feel our team should be aware of. Once you select the Provider, you’ll be able to submit feedback in the top right corner of the page.</p>
              <h4>What if the Provider has questions about your insurance?</h4>
              <p>Ask the Provider to call the number on your ID card to verify coverage and benefits. If the Provider refuses, call your Health Plan and ask them to reach out to the Provider. Your plan will notify you if they were able to resolve the issue. If not, they may give you alternate options.</p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="1">
            <h2>Balance Billing</h2>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <h4>What is a Balance Bill</h4>
              <p>If the Provider bill states you owe more than your Patient Responsibility on your Explanation of Benefits (EOB), this is a Balance Bill.</p>
              <h4>Who Can I call for Help</h4>
              <p>If you think you’ve received a balance bill,  contact your plan. They can connect you with an AMPS Member Advocate who can answer any questions you may have about balance billing. If a dispute is filed, an AMPS Member Advocate will send you a Balance Bill Kit and handle communications with the Provider. </p>
              <h4>What is a Balance Bill Kit</h4>
              <p>Documents that help explain the dispute process and gives AMPS the right to speak on your behalf to the Provider.</p>
              <p>After you send your possible Balance Bill to AMPS, AMPS Advocacy team will review your documentation. If it is a true Balance Bill, they will send you a Balance Bill Kit to start the dispute process.</p>
              <h4>When Should I alert AMPS</h4>
              <p>As soon as you believe you have a Balance Bill. Under the Fair Credit Billing Act (FCBA), a consumer has 60 days to dispute an invalid balance. Disputes filed after 60 days are not protected under the FCBA. The 60 days starts from the date on the first statement you are sent, not the date of service.</p>
              <h4>What Happens After We File a Dispute</h4>
              <p>In most cases, the Provider accepts payment once the dispute is filed. However, Providers may appeal directly to AMPS for additional payment. AMPS will review and may adjust the benefit allowable if the Provider presents additional information to warrant an additional payment.</p>

              <p>Alternatively, the Provider may balance bill again for the denied charges. If that happens, make sure to alert your AMPS Member Advocate.</p>

              <p>The most important and most difficult task on your part is to stand firm. The length of time it takes to reach resolution will be dependent on the specifics of your claims -- the typical time frame is 12-18 months. Remember: Provider bills are automatically generated – you may even receive one while AMPS is disputing the additional charges on the balance bill. Always let your AMPS Advocate know when you’ve received additional documentation from a Provider.</p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="2">
            <h2>Procedure Shopper</h2>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="2">
            <Card.Body>
              <h4>What is the Procedure Shopper</h4>
              <p>AMPS Care Navigators can also assist you in scheduling an appointment with contracted Providers for high-cost diagnostic imaging and non-emergent, elective surgical procedures. Follow this chart to see if you qualify for the Care Navigation scheduling service.</p>
              <h4>What is a Care Navigator</h4>
              <p>A Care Navigator is an extension of your health care team. They are there to help you shop for your high cost procedure.</p>
              <h4>What Procedures Can I Get Assistance With</h4>
              <p>Care Navigators can assist with MRI, CT and PET Scans as well as elective surgery procedures. Knee replacement, colonoscopies, and hernia repairs are just some examples of elective procedures they can assist you with.</p>
              <h4>Is this for Urgent Care</h4>
              <p>No! If you are experiencing a medical emergency seek immediate care. In case of a life-threatening emergency, dial 911.</p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="3">
            <h2>Registration and Access</h2>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="3">
            <Card.Body>
              <h4>How Can I Access My Dependents</h4>
              <p>They will need to grant you access. Fill out the below for the request to be sent to your dependents. If you have anyone under the age of 18, you will be able to fill out your request here.</p>
              <h4>My Contact Information Needs Updating</h4>
              <p>Contact your plan via the number on your ID card. Keeping your contact information up to date is very important for our teams to be in touch for Balance Billing and any procedure needs.</p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="4">
            <h2>AMPS</h2>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="4">
            <Card.Body>
              <h4>Who is AMPS</h4>
              <p>Your Plan has partnered with Advanced Medical Pricing Solutions (AMPS) to help combat rising healthcare costs by paying Providers what is fair and reasonable for healthcare services.</p>
              <h4>How Can AMPS Help</h4>
              <p>AMPS audits each and every claim submitted by your Plan. AMPS backs up the price with a Physician Review to find additional savings. By utilizing Physicians, AMPS uses their expertise to identify unreasonable charges and billing errors. AMPS billing review and pricing processes will result in lower costs for your Plan, which also means lower out-of-pocket costs for you.</p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>

        <Card>
          <Accordion.Toggle as={Card.Header} eventKey="5">
            <h2>Disclaimer</h2>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="5">
            <Card.Body>
              <p>DISCLAIMER: The information provided by AMPS Care Navigation or through the Provider Search should only be used as a guide when choosing care and is only intended for informational purposes only. AMPS Care Navigation does not practice medicine and cannot make any judgment or recommendation for treatment or diagnosis. No responsibility is assumed by AMPS, nor anyone connected with AMPS, for the use of this information. AMPS does not provide guaranties of any kind including accuracy of data, Plan coverage and treatment. All decisions of where a Member should seek treatment is solely up to the Member.</p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>


      </Accordion> */}
    </Container>
  );
};
export default withTranslation()(Support);
